<template>
  <div>
    <treeselect
        :multiple="false"
        v-model="model"
        :name="name"
        :options="options"
        noResultsText="Nichts gefunden"
        placeholder=""
    >
    </treeselect>
  </div>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: { treeselect },

  props: {
    options: Array,
    name: String,
    value: String,
  },

  data() {
    return {
      model: null,
    }
  },

  mounted() {
    // prefill old values
    this.model = this.value ? this.value : null
  },
}
</script>

<style scoped>
/* make the placeholder black so it matches other selects */
.vue-treeselect__placeholder {
  color: black;
}

.vue-treeselect--focused .vue-treeselect__placeholder {
  color: #BDBDBD;
}
</style>